var url_params = JSON.parse(sessionStorage.getItem('url_params'));
if(url_params && url_params.ver){
    var inputs = document.querySelectorAll('a');
    var formAction = '';
    var href = '';

    if(inputs.length > 0){
        inputs.forEach(function(input){
            if(input.getAttribute("href") && input.getAttribute("href").indexOf("#") == -1){
                href = input.getAttribute("href");
                input.setAttribute('href', href + '?ver=' + url_params.ver);
            }
        });
    }
}
